import * as types from './actionTypes';

// `request` carries page_number / page_size / sort_column / sort_direction.
export const fetchFullBuildExecutionResults = (request = {}) => ({
    type: types.FETCH_FULL_BUILD_EXECUTION_RESULTS,
    payload: request
});
export const fetchFullBuildExecutionResultsSuccess = (response) => ({
    type: types.FETCH_FULL_BUILD_EXECUTION_RESULTS_SUCCESS,
    payload: response
});
export const fetchFullBuildExecutionResultsFailure = (error) => ({
    type: types.FETCH_FULL_BUILD_EXECUTION_RESULTS_FAILURE,
    payload: error
});

export const fetchPrBuildExecutionResults = (request = {}) => ({
    type: types.FETCH_PR_BUILD_EXECUTION_RESULTS,
    payload: request
});
export const fetchPrBuildExecutionResultsSuccess = (response) => ({
    type: types.FETCH_PR_BUILD_EXECUTION_RESULTS_SUCCESS,
    payload: response
});
export const fetchPrBuildExecutionResultsFailure = (error) => ({
    type: types.FETCH_PR_BUILD_EXECUTION_RESULTS_FAILURE,
    payload: error
});

export const fetchSuiteResults = (executionId) => ({
    type: types.FETCH_SUITE_RESULTS,
    payload: executionId
});
export const fetchSuiteResultsSuccess = (id, data) => ({
    type: types.FETCH_SUITE_RESULTS_SUCCESS,
    payload: { id, data }
});
export const fetchSuiteResultsFailure = (error) => ({
    type: types.FETCH_SUITE_RESULTS_FAILURE,
    payload: error
});

export const fetchCsvReport = (semaphoreWorkflowId) => ({
    type: types.FETCH_CSV_REPORT,
    payload: semaphoreWorkflowId
});
export const fetchCsvReportSuccess = (id, data) => ({
    type: types.FETCH_CSV_REPORT_SUCCESS,
    payload: { id, data }
});
export const fetchCsvReportFailure = (error) => ({
    type: types.FETCH_CSV_REPORT_FAILURE,
    payload: error
});

export const setSelectedExecution = (execution) => ({
    type: types.SET_SELECTED_EXECUTION,
    payload: execution
});
export const setModalOpen = (isOpen) => ({
    type: types.SET_MODAL_OPEN,
    payload: isOpen
});